import React from 'react';
import { Image as BaseImage, ImageProps as BaseImageProps } from 'antd';


export interface ImageProps extends BaseImageProps { };

const Image: React.FC<ImageProps> = ({ className, ...props }) => <BaseImage {...props} className={className} />;

export default Image;
